// Ensure Shopify money formatting is available
if (typeof Shopify === 'undefined') Shopify = {};
if (typeof Shopify.formatMoney === 'undefined') {
  Shopify.formatMoney = function (cents, format) {
    if (typeof cents === 'string') { cents = cents.replace('.', ''); }
    if (typeof format === 'undefined') { format = "${{amount}}"; }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    function formatWithDelimiters(number) {
      var parts = number.toFixed(2).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return parts.join('.');
    }
    value = formatWithDelimiters(cents / 100);
    return format.replace(placeholderRegex, value);
  };
}

// Helper function to detect currency format from existing price text
function detectCurrencyFormat(priceText) {
  var moneyFormat = '${{amount}}'; // default fallback
  
  if (priceText.includes('¥')) {
    moneyFormat = '¥{{amount}}';
  } else if (priceText.includes('€')) {
    moneyFormat = '€{{amount}}';
  } else if (priceText.includes('£')) {
    moneyFormat = '£{{amount}}';
  } else if (priceText.includes('₹')) {
    moneyFormat = '₹{{amount}}';
  } else if (priceText.includes('₽')) {
    moneyFormat = '₽{{amount}}';
  } else if (priceText.includes('¢')) {
    moneyFormat = '{{amount}}¢';
  } else if (window.theme && window.theme.moneyFormat) {
    moneyFormat = window.theme.moneyFormat;
  }
  
  return moneyFormat;
}

// Handling variant changes with price updates
$(document).on('click', '.js_single_variant_change', function() {
  var variantID = $(this).attr('variantID');
  var $card = $(this).parents('.product-card');
  
  
  // Update active state
  $card.find('.js_single_variant_change').removeClass('active');
  $(this).addClass('active');
  $card.attr('data', variantID);
  $card.find('input[name="id"]').attr({
    'value': variantID, 
    'data-value': variantID
  });

  // Update price display for the new variant
  updateVariantPricing($card, variantID);
});

// Function to update variant pricing display
function updateVariantPricing($card, variantID) {
  try {
    // Get product data from the form
    var productData = JSON.parse($card.find('form').attr('data'));
    
    // Find the selected variant
    var selectedVariant = productData.variants.find(function(variant) {
      return variant.id == variantID;
    });
    
    if (selectedVariant) {
      // Get the original price element to maintain the same formatting
      var $priceEl = $card.find('.gf_product-price');
      var $comparePriceEl = $card.find('.gf_product-compare-price');
      
      // Get the current money format from existing price elements
      var existingPriceText = $priceEl.text().trim();
      var moneyFormat = detectCurrencyFormat(existingPriceText);
      
      // Store original classes and styling before updating
      var originalPriceClasses = $priceEl.attr('class');
      var originalPriceStyle = $priceEl.attr('style');
      var originalPriceAttrs = {};
      
      // Capture all original attributes except class and style
      $.each($priceEl[0].attributes, function() {
        if (this.name !== 'class' && this.name !== 'style') {
          originalPriceAttrs[this.name] = this.value;
        }
      });
      
      // Update price text while preserving all styling
      $priceEl.text(Shopify.formatMoney(selectedVariant.price, moneyFormat));
      
      // Restore original styling
      if (originalPriceClasses) $priceEl.attr('class', originalPriceClasses);
      if (originalPriceStyle) $priceEl.attr('style', originalPriceStyle);
      $.each(originalPriceAttrs, function(name, value) {
        $priceEl.attr(name, value);
      });
      
      // Update compare price if it exists
      if (selectedVariant.compare_at_price && selectedVariant.compare_at_price > selectedVariant.price) {
        // Store original compare price styling
        var originalCompareClasses = $comparePriceEl.attr('class');
        var originalCompareStyle = $comparePriceEl.attr('style');
        
        $comparePriceEl.text(Shopify.formatMoney(selectedVariant.compare_at_price, moneyFormat));
        
        // Restore original styling
        if (originalCompareClasses) $comparePriceEl.attr('class', originalCompareClasses);
        if (originalCompareStyle) $comparePriceEl.attr('style', originalCompareStyle);
        $comparePriceEl.show();
        
        // Update discount percentage if applicable
        var discountPercent = Math.round(((selectedVariant.compare_at_price - selectedVariant.price) / selectedVariant.compare_at_price) * 100);
        $card.find('.gf_pq-percent').text(discountPercent + '%');
        $card.find('.gf_pq-discount-selector').show();
      } else {
        $comparePriceEl.hide();
        $card.find('.gf_pq-discount-selector').hide();
      }
      
      // Update Skio subscription prices if they exist
      updateSkioPricesForVariant($card, selectedVariant);
    }
  } catch (error) {
    console.warn('Could not update variant pricing:', error);
  }
}

// Function to update Skio subscription prices for the selected variant
function updateSkioPricesForVariant($card, variant) {
  try {
    var basePrice = variant.price;

    // Get currency format from the main price element
    var existingPriceText = $card.find('.gf_product-price').text().trim();
    var moneyFormat = detectCurrencyFormat(existingPriceText);

    // Update Skio price elements for each selling plan group
    $card.find('.skio-group-container').each(function() {
      var $groupContainer = $(this);
      var $sellingPlanGroup = $groupContainer.find('.skio-group-input[skio-selling-plan-group]');

      if ($sellingPlanGroup.length) {
        // This is a subscription group
        var $sellingPlanSelect = $groupContainer.find('.skio-frequency');
        var selectedSellingPlanId = parseInt($sellingPlanSelect.val()) || parseInt($sellingPlanSelect.find('option:first').val());

        // Find the selling plan allocation for this variant and selling plan
        var sellingPlanAllocation = variant.selling_plan_allocations?.find(function(allocation) {
          return allocation.selling_plan_id == selectedSellingPlanId;
        });

        if (sellingPlanAllocation) {
          var subscriptionPrice = sellingPlanAllocation.price;

          // Update the subscription price display
          var $skioPrice = $groupContainer.find('.skio-price span');
          var originalClasses = $skioPrice.attr('class');
          var originalStyle = $skioPrice.attr('style');

          $skioPrice.text(Shopify.formatMoney(subscriptionPrice, moneyFormat));
          $skioPrice.attr('product_price', subscriptionPrice);

          // Restore original styling
          if (originalClasses) $skioPrice.attr('class', originalClasses);
          if (originalStyle) $skioPrice.attr('style', originalStyle);
        }
      } else {
        // This is the one-time group
        var $skioPrice = $groupContainer.find('.skio-price span');
        if ($skioPrice.length) {
          var originalClasses = $skioPrice.attr('class');
          var originalStyle = $skioPrice.attr('style');

          $skioPrice.text(Shopify.formatMoney(basePrice, moneyFormat));
          $skioPrice.attr('regular_price', basePrice);

          // Restore original styling
          if (originalClasses) $skioPrice.attr('class', originalClasses);
          if (originalStyle) $skioPrice.attr('style', originalStyle);
        }
      }
    });
  } catch (error) {
    console.warn('Could not update Skio prices:', error);
  }
}

// Subscription plan changes - now also updates main product card price
$(document).on('change', '.skio-group-input', function() {
  var $card = $(this).parents('.product-card');
  var variant_id = $(this).parents('form').find('input[name="id"]').attr('data-value'),
      subscription_price = parseInt($(this).parents('form').find('.skio-group-container.skio-group-container--available .skio-group-input:checked+label .skio-price > span').attr('product_price')),
      regular_price = parseInt($(this).parents('form').find('.skio-group-container.skio-group-container--available .skio-group-input[skio-one-time]+label .skio-price > span').attr('regular_price')),
      total_qty = parseInt($(this).parents('form').find('.qtybox .inputQty').val());
  
  // Make sure total_qty is at least 1
  total_qty = total_qty || 1;

  // Get currency format from main price element
  var existingPriceText = $card.find('.gf_product-price').text().trim();
  var moneyFormat = detectCurrencyFormat(existingPriceText);
  
  if (this.hasAttribute('skio-one-time')) {
    // One-time purchase selected
    var total_price = regular_price * total_qty;
    
    // Update main product card price to show regular price while preserving styling
    var $mainPriceEl = $card.find('.gf_product-price');
    var mainPriceClasses = $mainPriceEl.attr('class');
    var mainPriceStyle = $mainPriceEl.attr('style');
    
    $mainPriceEl.text(Shopify.formatMoney(regular_price, moneyFormat));
    
    // Restore styling
    if (mainPriceClasses) $mainPriceEl.attr('class', mainPriceClasses);
    if (mainPriceStyle) $mainPriceEl.attr('style', mainPriceStyle);
    
    // Update bundle items if they exist
    if ($('.added-product.buy_item[data="' + variant_id + '"]').length) {
      $('.added-product.buy_item[data="' + variant_id + '"] .r_price')
        .text(Shopify.formatMoney(total_price, moneyFormat))
        .attr('data', total_price);
    }
    $('.added-product.buy_item[data="' + variant_id + '"] .selling_plan_title').text('One-Time Purchase');
  } else {
    // Subscription selected
    var total_price = subscription_price * total_qty;
    
    // Update main product card price to show subscription price (12% off) while preserving styling
    var $mainPriceEl = $card.find('.gf_product-price');
    var mainPriceClasses = $mainPriceEl.attr('class');
    var mainPriceStyle = $mainPriceEl.attr('style');
    
    $mainPriceEl.text(Shopify.formatMoney(subscription_price, moneyFormat));
    
    // Restore styling
    if (mainPriceClasses) $mainPriceEl.attr('class', mainPriceClasses);
    if (mainPriceStyle) $mainPriceEl.attr('style', mainPriceStyle);
    
    // Update bundle items if they exist
    if ($('.added-product.buy_item[data="' + variant_id + '"]').length) {
      $('.added-product.buy_item[data="' + variant_id + '"] .r_price')
        .text(Shopify.formatMoney(total_price, moneyFormat))
        .attr('data', total_price);
    }
    
    let frq_val = $(this).parents('.skio-group-container').find('label .skio-frequency').val(),
        frq_text = $(this).parents('.skio-group-container').find('label .skio-frequency option[value="' + frq_val + '"]').text();
    
    $('.added-product.buy_item[data="' + variant_id + '"] .selling_plan_title').text(frq_text);
  }
  
});

// Subscription frequency changes
$(document).on('change', '.subscription_picker .skio-plan-picker .skio-frequency', function() {
  var variant_id = $(this).parents('form').find('input[name="id"]').attr('data-value'),
      frq_val = $(this).val(),
      frq_text = $(this).find('option[value="' + frq_val + '"]').text();
  
  $('.added-product.buy_item[data="' + variant_id + '"] .selling_plan_title').text(frq_text);
});

// Add to cart functionality for subscription products - with direct cart redirect
$(document).on('click', '.js_subscription_atc', function() {
  var _this = $(this),
      pro_var_id = parseInt($(_this).parents('form').find('input[name="id"]').attr('data-value')),
      product_qty = parseInt($(_this).parents('form').find('input[name="quantity"]').val()),
      selling_plan_id = null;
  
  // Show loader
  $(_this).addClass('loader_show');
  
  // Ensure at least quantity of 1
  if (product_qty === 0 || isNaN(product_qty)) {
    product_qty = 1;
    $(_this).parents('form').find('input[name="quantity"]').val('1');
  }
  
  // Check if it's a subscription or one-time purchase
  if (!$(_this).parents('form').find('.skio-group-input[skio-one-time]:checked').length) {
    try {
      selling_plan_id = parseInt($(_this).parents('form').find('.skio-group-container.skio-group-container--available .skio-group-content select').val());
    } catch (e) {
      console.warn('Could not get selling plan ID:', e);
    }
  }
  
  // Prepare Ajax request data
  let requestData = {
    id: pro_var_id,
    quantity: product_qty
  };
  
  // Only add selling_plan if it's valid
  if (selling_plan_id && !isNaN(selling_plan_id)) {
    requestData.selling_plan = selling_plan_id;
  }
  
  // Add to cart via AJAX and redirect to cart page
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    dataType: 'json',
    data: requestData,
    success: function (data) {
  // Refresh Dawn cart sections, then open the drawer
  const sections = ['cart-drawer', 'cart-icon-bubble'];

  Promise.all(
    sections.map((id) =>
      fetch(`${window.Shopify.routes.root}?section_id=${id}`).then((r) => r.text())
    )
  )
    .then(([drawerHTML, bubbleHTML]) => {
      const parser = new DOMParser();

      // Replace the cart drawer section
      const drawerDoc = parser.parseFromString(drawerHTML, 'text/html');
      const newDrawer = drawerDoc.querySelector('cart-drawer');
      const curDrawer = document.querySelector('cart-drawer');
      if (newDrawer && curDrawer) curDrawer.replaceWith(newDrawer);

      // Replace the cart icon bubble
      const bubbleDoc = parser.parseFromString(bubbleHTML, 'text/html');
      const newBubble = bubbleDoc.getElementById('cart-icon-bubble');
      const curBubble = document.getElementById('cart-icon-bubble');
      if (newBubble && curBubble) curBubble.replaceWith(newBubble);

      // Open the native Dawn drawer
      document.querySelector('cart-drawer')?.open();
    })
    .catch((e) => console.warn('Drawer refresh failed:', e))
    .finally(() => {
      $(_this).removeClass('loader_show');
    });
},
    error: function(error) {
      console.error('Add to cart error:', error.responseJSON?.description || 'Unknown error');
      
      // Show error message to user
      if (error.responseJSON?.description) {
        alert(error.responseJSON.description);
      }
      
      // Hide loader
      $(_this).removeClass('loader_show');
    }
  });
});
$(document).ready(function() {
  $(document).on("click", ".accordion", function() {
    $(this).parents('.slide_up_down').find('.panel').slideUp();
    if ($(this).hasClass("active")) {
      $(this).removeClass('active');
      $(this).siblings('.panel').slideUp();
    } else {
      $(this).parents('.slide_up_down').find('.accordion').removeClass('active');
      $(this).addClass('active');
      $(this).siblings('.panel').slideDown();
    }
  });
});
